// ============================================
// Creator Events - Lorebook
// 로어북 이벤트 핸들러
// ============================================

import {
  openLorebookModal,
  closeLorebookModal,
  saveLorebookEntryData,
  deleteLorebookEntryData,
  deleteLorebookEntry,
  addKeyword,
  removeKeyword,
  initLorebookCounters,
  toggleLorebookSection
} from '../editor/lorebook.js';

// ============================================
// 이벤트 초기화
// ============================================

export function initLorebookEvents() {
  // 고급 탭 이벤트 위임
  const advancedTab = document.getElementById('editorTabAdvanced');
  if (advancedTab) {
    advancedTab.addEventListener('click', handleAdvancedTabClick);
  }

  // 모달 이벤트 위임
  const modal = document.getElementById('lorebookEditModal');
  if (modal) {
    modal.addEventListener('click', handleModalClick);
  }

  // 키워드 입력 이벤트
  const keywordInput = document.getElementById('lorebookKeywordInput');
  if (keywordInput) {
    keywordInput.addEventListener('keydown', handleKeywordInputKeydown);
  }

  // 글자 수 카운터 초기화
  initLorebookCounters();
}

// ============================================
// 핸들러
// ============================================

function handleAdvancedTabClick(e) {
  const actionEl = e.target.closest('[data-action]');
  if (!actionEl) return;

  const action = actionEl.dataset.action;
  const index = parseInt(actionEl.dataset.index);

  switch (action) {
    case 'toggleLorebookSection':
      toggleLorebookSection();
      break;
    case 'addLorebookEntry':
      openLorebookModal(null);
      break;
    case 'editLorebook':
      if (!isNaN(index)) {
        openLorebookModal(index);
      }
      break;
    case 'deleteLorebook':
      e.stopPropagation();
      if (!isNaN(index)) {
        deleteLorebookEntry(index);
      }
      break;
  }
}

function handleModalClick(e) {
  const actionEl = e.target.closest('[data-action]');

  // 키워드 삭제 버튼
  const removeBtn = e.target.closest('.keyword-tag-remove');
  if (removeBtn) {
    const index = parseInt(removeBtn.dataset.keywordIndex);
    if (!isNaN(index)) {
      removeKeyword(index);
    }
    return;
  }

  if (!actionEl) return;

  const action = actionEl.dataset.action;

  switch (action) {
    case 'closeLorebookModal':
      closeLorebookModal();
      break;
    case 'saveLorebookEntry':
      saveLorebookEntryData();
      break;
    case 'deleteLorebookEntry':
      deleteLorebookEntryData();
      break;
    case 'addLorebookKeyword':
      handleAddKeywordClick();
      break;
  }
}

function handleAddKeywordClick() {
  const input = document.getElementById('lorebookKeywordInput');
  if (input && addKeyword(input.value)) {
    input.value = '';
    input.focus();
  }
}

function handleKeywordInputKeydown(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
    const input = e.target;
    if (addKeyword(input.value)) {
      input.value = '';
    }
  }
}
